export default __webpack_public_path__ + "static/media/fondo1.6abcc88a.jpg";